import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  template: `
    <input
      *ngIf="isBoolean(value); else noValue"
      type="checkbox"
      [disabled]="!disabled"
      [checked]="value"
      (change)="onChange($event)"
    />
    <ng-template #noValue>-</ng-template>
  `,
})
export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
  value: boolean;
  disabled: boolean;
  params: any;

  agInit(params: any): void {
    this.params = params;
    this.value = params.data.get(params.colDef.field).value;
    this.disabled = params.globallyEnabled;
  }

  isBoolean(val: any): val is boolean {
    return typeof val === 'boolean';
  }

  onChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.params.data.get(this.params.colDef.field).setValue(checked);
  }

  refresh(): boolean {
    return true;
  }
}
